export default __webpack_public_path__ + "static/media/longhairguy.a4a68070.jpeg";